// @core/api/endpoints/payment/create_payment_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePaymentPolicyRequest,
  PaymentPolicyResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Create payment policy
 * Creates a payment policy for a scope entity defining routing, cascade, and 3DS behavior.
 */
export async function CreatePaymentPolicy(
  data: CreatePaymentPolicyRequest,
  options?: RequestOptions
): Promise<PaymentPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payment-policies`;
  const requestOptions = options;
  return client.post<PaymentPolicyResponse>(requestPath, data, requestOptions);
}
